import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import React, { forwardRef, useEffect } from 'react';
import { FlexBox } from '../box';
import { useIsInDialog } from '../dialog';
import { Divider } from '../divider';
import { IconExpandMore } from '../icon';
import { Item } from '../list/item';
import { Menu } from '../menu';
import { styled } from '../styled';
import { Typography } from '../typography';
export * from './list';
const AccordionItem = styled(Item)(({ theme }) => ({
    paddingRight: theme.spacing(2)
}));
const AccordionDetails = (props) => {
    return (_jsx(MuiAccordionDetails, { ...props, children: props.children }));
};
const StyledSummary = styled(FlexBox)({
    paddingLeft: 0,
    paddingRight: 0,
    fontWeight: 'bold'
});
const StyledAccordionDetails = styled(AccordionDetails)(({ theme, $inDialog }) => ({
    ...($inDialog && {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: theme.spacing(2)
    })
}));
export const Accordion = (props) => {
    const { expanded: _expanded = false, actions = [], summary, details, children, onExpandedChange, ...accordionProps } = props;
    const ref = React.useRef(null);
    const [expanded, setExpanded] = React.useState(_expanded);
    const inDialog = useIsInDialog();
    const summaryPrimary = props.summary?.primary ? (_jsx(Typography, { variant: "body1", fontWeight: "bold", children: props.summary.primary })) : null;
    const summaryProps = inDialog
        ? {
            ...summary,
            primary: summaryPrimary,
            slots: { ...summary.slots, root: StyledSummary }
        }
        : summary;
    useEffect(() => {
        setExpanded(_expanded);
    }, [_expanded]);
    return (_jsxs(InternalAccordion, { ref: ref, expanded: expanded, onChange: (e, isExpanded) => {
            if (e.target instanceof HTMLElement &&
                ref.current?.contains(e.target)) {
                setExpanded(isExpanded);
                onExpandedChange?.(isExpanded);
            }
        }, ...accordionProps, children: [_jsx(AccordionSummary, { ...summaryProps, slots: {
                    expandIconWrapper: ExpandIconWrapper,
                    ...summaryProps.slots
                }, slotProps: {
                    expandIconWrapper: { actions, expanded },
                    ...summaryProps.slotProps
                } }), _jsx(StyledAccordionDetails, { ...details, "$inDialog": inDialog, children: children })] }));
};
Accordion.displayName = 'Accordion';
const InternalAccordion = forwardRef((props, ref) => {
    const { fullWidth, hideDivider, ...accordionProps } = props;
    return (_jsxs(FlexBox, { stack: true, ...(fullWidth && { width: '100%' }), children: [_jsx(MuiAccordion, { elevation: 0, ...accordionProps, ref: ref, children: props.children }), !hideDivider && _jsx(Divider, {})] }));
});
const AccordionSummary = (props) => {
    const { expandIcon, classes, sx, className, slotProps, slots, ref, ...itemProps } = props;
    return (_jsx(MuiAccordionSummary, { component: "div", expandIcon: expandIcon || _jsx(IconExpandMore, {}), classes: classes, sx: sx, className: className, slotProps: slotProps, slots: slots, ref: ref, children: _jsx(AccordionItem, { ...itemProps }) }));
};
const ExpandIconWrapper = (props) => {
    const { actions = [], expanded } = props;
    return (_jsxs(FlexBox, { vAlign: "center", gap: 1, children: [_jsx("div", { className: props.className, style: {
                    pointerEvents: 'none',
                    lineHeight: 0,
                    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1)',
                    transform: `rotate(${expanded ? 180 : 0}deg)`
                }, children: props.children }), actions.length > 0 ? (_jsx(Menu, { icon: "IconMoreVert", iconProps: { fontSize: 'small' }, actions: actions })) : null] }));
};
